import Vue from 'vue'

// Advanced Search Field components
export const advancedSearchBooleanField = Vue.component(
  'advancedSearchBooleanField',
  require('_/components/AdvancedSearchFields/BooleanField/BooleanField.vue')
    .default
)
export const advancedSearchDateField = Vue.component(
  'advancedSearchDateField',
  require('_/components/AdvancedSearchFields/CalendarField/CalendarField.vue')
    .default
)
export const advancedSearchDateTimeField = Vue.component(
  'advancedSearchDateTimeField',
  require('_/components/AdvancedSearchFields/CalendarField/CalendarField.vue')
    .default
)
export const advancedSearchOneToOneExtendedField = Vue.component(
  'advancedSearchOneToOneExtendedField',
  require('_/components/FieldTypes/Blank/Blank.vue').default
)
export const advancedSearchOneToManyExtendedField = Vue.component(
  'advancedSearchOneToManyExtendedField',
  require('_/components/FieldTypes/Blank/Blank.vue').default
)
export const advancedSearchManyToOneExtendedField = Vue.component(
  'advancedSearchManyToOneExtendedField',
  require('_/components/FieldTypes/Blank/Blank.vue').default
)
export const advancedSearchRelationshipExtendedField = Vue.component(
  'advancedSearchRelationshipExtendedField',
  require('_/components/FieldTypes/Blank/Blank.vue').default
)
export const advancedSearchFileField = Vue.component(
  'advancedSearchFileField',
  require('_/components/AdvancedSearchFields/InputTextField/InputTextField.vue')
    .default
)
export const advancedSearchInputTextField = Vue.component(
  'advancedSearchInputTextField',
  require('_/components/AdvancedSearchFields/InputTextField/InputTextField.vue')
    .default
)
export const advancedSearchSimpleTextField = Vue.component(
  'advancedSearchInputTextField',
  require('_/components/AdvancedSearchFields/InputTextField/InputTextField.vue')
    .default
)
export const advancedSearchIntegerField = Vue.component(
  'advancedSearchIntegerField',
  require('_/components/AdvancedSearchFields/IntegerField/IntegerField.vue')
    .default
)
export const advancedSearchOneToOneField = Vue.component(
  'advancedSearchOneToOneField',
  require('_/components/AdvancedSearchFields/MultiSelectField/MultiSelectField.vue')
    .default
)
export const advancedSearchOneToManyField = Vue.component(
  'advancedSearchOneToManyField',
  require('_/components/AdvancedSearchFields/MultiSelectField/MultiSelectField.vue')
    .default
)
export const advancedSearchManyToOneField = Vue.component(
  'advancedSearchManyToOneField',
  require('_/components/AdvancedSearchFields/MultiSelectField/MultiSelectField.vue')
    .default
)
export const advancedSearchRelationshipField = Vue.component(
  'advancedSearchRelationshipField',
  require('_/components/AdvancedSearchFields/MultiSelectField/MultiSelectField.vue')
    .default
)
export const advancedSearchRichTextField = Vue.component(
  'advancedSearchRichTextField',
  require('_/components/AdvancedSearchFields/InputTextField/InputTextField.vue')
    .default
)
export const advancedSearchSystemDateTimeField = Vue.component(
  'advancedSearchSystemDateTimeField',
  require('_/components/AdvancedSearchFields/InputTextField/InputTextField.vue')
    .default
)
export const advancedSearchSystemStringField = Vue.component(
  'advancedSearchSystemDateTimeField',
  require('_/components/AdvancedSearchFields/InputTextField/InputTextField.vue')
    .default
)
